import { useRef } from 'react';
import type { HistoryApiResponse } from '../types/exportTypes';

export interface ExportHistoryCache {
  data: HistoryApiResponse | null;
  pageSize: number;
  currentPage: number;
}

export const createExportHistoryCache = () => {
  return useRef<ExportHistoryCache>({
    data: null,
    pageSize: 25,
    currentPage: 1
  });
};

export const canUseCachedData = (
  cache: ExportHistoryCache,
  hasFilters: boolean,
  pageSize: number,
  currentPage: number,
  forceRefresh: boolean = false
): boolean => {
  return (
    !hasFilters &&
    cache.data !== null &&
    cache.pageSize === pageSize &&
    cache.currentPage === currentPage &&
    !forceRefresh
  );
};

export const updateCache = (
  cacheRef: React.MutableRefObject<ExportHistoryCache>,
  data: HistoryApiResponse,
  pageSize: number,
  currentPage: number
): void => {
  cacheRef.current = {
    data,
    pageSize,
    currentPage
  };
};

export const canRestoreFromCache = (cache: ExportHistoryCache, pageSize: number): boolean => {
  return !!(cache.data && cache.pageSize === pageSize && cache.currentPage === 1);
};
